import {
  ActivateCodeRequest,
  RegisterUserRequest,
} from '@tsin-core/models/guest.model';

const ACTION_SCOPE = '[Guest]';

export class ActivateCode {
  static readonly type = `${ACTION_SCOPE} Activate Code`;
  constructor(public payload: ActivateCodeRequest) {}
}

export class RegisterUser {
  static readonly type = `${ACTION_SCOPE} Register User`;
  constructor(public payload: RegisterUserRequest) {}
}
